export function isDogmaAiEnabled(
  appSettings?: { enableDogmaAI?: boolean } | null
): boolean {
  return !!appSettings?.enableDogmaAI;
}
